<template>
  <div class="settings-page">
    <base-header class="pb-6 pb-7 pt-5 pt-md-7 bg-gradient">
      <h2 class="page-title">Настройки</h2>
    </base-header>

    <b-container fluid class="mt--6">
      <b-row>
        <b-col xl="6" lg="8">
          <div class="settings-card">
            <div class="settings-card-header">
              <div class="header-icon">
                <i class="ni ni-key-25"></i>
              </div>
              <div class="header-text">
                <h3>API Токен</h3>
                <p>Используется для авторизации внешних запросов</p>
              </div>
            </div>

            <div class="settings-card-body">
              <div class="token-display">
                <code class="token-value">{{ settings.token || '—' }}</code>
                <button
                  type="button"
                  class="copy-btn"
                  @click="copyToken"
                  title="Копировать"
                  :disabled="!settings.token"
                >
                  <i class="ni ni-single-copy-04"></i>
                </button>
              </div>
            </div>

            <div class="settings-card-footer">
              <button
                type="button"
                class="btn-reset"
                @click="RevokeToken"
              >
                <i class="ni ni-refresh-02"></i>
                Сбросить токен
              </button>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import axios from 'axios'

export default {
  data() {
    return {
      settings: {
          "token": null
      }
    }
  },
  methods: {
    async Settings() {
      const response = await axios.get('dashboard/settings')
      this.settings.token = response.data.token
    },
    async RevokeToken() {
      if (confirm("Вы уверены что хотите сбросить токен?")) {
        const response = await axios.post('dashboard/settings/revoke')
        if (response.data.status === true) {
          this.$notify({
            title: 'Успешно',
            message: 'Токен авторизации сброшен.',
            type: 'success'
          });
        }
        this.settings.token = response.data.token
      }
    },
    async copyToken() {
      if (!this.settings.token) return;
      try {
        await navigator.clipboard.writeText(this.settings.token);
        this.$notify({
          title: 'Скопировано',
          message: 'Токен скопирован в буфер обмена',
          type: 'success'
        });
      } catch (err) {
        console.error('Failed to copy:', err);
      }
    }
  },
  mounted() {
    this.Settings();
  },
  created () {
  },
};
</script>

<style scoped lang="scss">
.settings-page {
  .page-title {
    color: #fff;
    font-size: 2rem;
    font-weight: 700;
    margin: 0;
  }
}

.bg-gradient {
  background: linear-gradient(87deg, #172b4d 0, #1a174d 100%) !important;
}

.settings-card {
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e8e8e8;
  overflow: hidden;
}

.settings-card-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.25rem;
  border-bottom: 1px solid #f0f0f0;

  .header-icon {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    background: rgba(67, 97, 238, 0.1);
    color: #4361EE;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    i {
      font-size: 1.1rem;
    }
  }

  .header-text {
    h3 {
      font-size: 1rem;
      font-weight: 600;
      color: #333;
      margin: 0 0 0.25rem 0;
    }

    p {
      font-size: 0.8rem;
      color: #909399;
      margin: 0;
    }
  }
}

.settings-card-body {
  padding: 1.25rem;
}

.token-display {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #f8f9fa;
  border-radius: 6px;
  padding: 0.75rem 1rem;

  .token-value {
    flex: 1;
    font-family: 'SF Mono', 'Monaco', 'Consolas', monospace;
    font-size: 0.85rem;
    color: #333;
    word-break: break-all;
    background: none;
    padding: 0;
  }

  .copy-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: none;
    border-radius: 4px;
    background: transparent;
    color: #909399;
    cursor: pointer;
    transition: background-color 0.15s ease, color 0.15s ease;
    flex-shrink: 0;

    &:hover:not(:disabled) {
      background: rgba(0, 0, 0, 0.06);
      color: #606266;
    }

    &:disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }

    i {
      font-size: 0.9rem;
    }
  }
}

.settings-card-footer {
  padding: 1rem 1.25rem;
  border-top: 1px solid #f0f0f0;
  background: #fafafa;

  .btn-reset {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 1rem;
    border: none;
    border-radius: 6px;
    background: transparent;
    color: #f56c6c;
    font-size: 0.85rem;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.15s ease;

    &:hover {
      background: rgba(245, 108, 108, 0.1);
    }

    i {
      font-size: 0.9rem;
    }
  }
}
</style>
